// extracted by mini-css-extract-plugin
export var banner = "styles-module--banner--2d453";
export var bannerClosed = "styles-module--bannerClosed--4cc99";
export var button = "styles-module--button--ca2b7";
export var cross = "styles-module--cross--59057";
export var drivaLogo = "styles-module--drivaLogo--306f5";
export var infoContainer = "styles-module--infoContainer--c9fb9";
export var middText = "styles-module--middText--afd4c";
export var middTextMobile = "styles-module--middTextMobile--d2b69";
export var partnerLogo = "styles-module--partnerLogo--9a41a";